module.exports = __webpack_public_path__ + "media/alarm.6f79f3a6.mp3";